import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Componentes de contabilidad
import DashboardContabilidad from "./components/DashboardContabilidad";
import PlanCuentas from "./components/PlanCuentas";
import AsientosContables from "./components/AsientosContables";
import LibroMayor from "./components/LibroMayor";
import BalanceGeneral from "./components/BalanceGeneral";
import EstadoResultados from "./components/EstadoResultados";
import FlujoCaja from "./components/FlujoCaja";
import ReportesContables from "./components/ReportesContables";

import { useMaterialUIController } from "context";

export default function Contabilidad() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderContent = () => {
    switch (tabValue) {
      case 0:
        return <DashboardContabilidad />;
      case 1:
        return <PlanCuentas />;
      case 2:
        return <AsientosContables />;
      case 3:
        return <LibroMayor />;
      case 4:
        return <BalanceGeneral />;
      case 5:
        return <EstadoResultados />;
      case 6:
        return <FlujoCaja />;
      case 7:
        return <ReportesContables />;
      default:
        return <DashboardContabilidad />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Módulo de Contabilidad
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  sx={{ px: 3 }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="Dashboard" icon={<Icon>dashboard</Icon>} iconPosition="start" />
                  <Tab
                    label="Plan de Cuentas"
                    icon={<Icon>account_tree</Icon>}
                    iconPosition="start"
                  />
                  <Tab
                    label="Asientos Contables"
                    icon={<Icon>receipt_long</Icon>}
                    iconPosition="start"
                  />
                  <Tab label="Libro Mayor" icon={<Icon>menu_book</Icon>} iconPosition="start" />
                  <Tab
                    label="Balance General"
                    icon={<Icon>account_balance</Icon>}
                    iconPosition="start"
                  />
                  <Tab
                    label="Estado de Resultados"
                    icon={<Icon>trending_up</Icon>}
                    iconPosition="start"
                  />
                  <Tab label="Flujo de Caja" icon={<Icon>payments</Icon>} iconPosition="start" />
                  <Tab label="Reportes" icon={<Icon>assessment</Icon>} iconPosition="start" />
                </Tabs>
              </MDBox>
              <MDBox p={3}>{renderContent()}</MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
